module.exports = __webpack_public_path__ + "static/media/fn-showcase.9598c936.png";